module.exports = __webpack_public_path__ + "static/media/unit 3-11.cab9b408.jpg";